import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import ProChioseTree from "@/components/pro-common/pro-chiose-modal/pro-chiose-tree.vue";
export default {
  name: "pro-chiose-tab-member",
  components: {
    ProChioseTree
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    _treeData() {
      let treeData = JSON.parse(JSON.stringify(this.treeData));
      return this.changeTree(treeData);
    }
  },
  methods: {
    filterTree(tree, conditionFn) {
      // 如果是数组（多个根节点），则处理每个节点
      if (Array.isArray(tree)) {
        return tree.map(node => this.filterTree(node, conditionFn)).filter(Boolean);
      }

      // 如果是单个节点
      if (tree && tree.children) {
        // 过滤子节点
        tree.children = tree.children.map(child => this.filterTree(child, conditionFn)).filter(Boolean);

        // 如果当前节点不符合条件且没有子节点，则返回null（会被过滤掉）
        if (!conditionFn(tree) && (!tree.children || tree.children.length === 0)) {
          return null;
        }
      }

      // 返回符合条件的节点
      return conditionFn(tree) ? tree : null;
    },
    changeTree(treeData) {
      const DG = (arr, boo) => {
        arr.forEach(v => {
          v.expand = boo || false;
          v.disabled = true;
          if (v.orgId) {
            v.isCheckDisabled = true;
          }
          if (v.userId) {
            v.name = v.userName;
          }
          v.children = [...(v.children || []), ...(v.organizationUsers || [])];
          if (v.children && v.children.length > 0) {
            DG(v.children);
          }
        });
      };
      // 合并部门跟成员
      DG(treeData, true);
      // 删除没有成员的部门
      treeData = this.filterTree(treeData, node => {
        let nodePass = false;
        let change = arr => {
          arr.forEach(v => {
            if (v.orgId) {
              if (v.children.length > 0) {
                change(v.children);
              }
            } else {
              nodePass = true;
            }
          });
        };
        change([node]);
        return nodePass;
      });
      return treeData;
    },
    /*
     * 清空
     */
    clearAll() {
      let dg = arr => {
        arr.forEach(v => {
          v.isCheck = false;
          if (v.children && v.children.length > 0) {
            dg(v.children);
          }
        });
      };
      dg(this._treeData);
    },
    /*
     * 清空一个
     */
    clearOne(item) {
      let dg = (arr, i) => {
        arr.forEach(v => {
          if (v.userId === i.userId) {
            v.isCheck = false;
          }
          if (v.children && v.children.length > 0) {
            dg(v.children, i);
          }
        });
      };
      dg(this._treeData, item);
    },
    onChange(item) {
      let checkedList = [...this.value];
      if (item.isCheck) {
        checkedList.unshift(item);
      } else {
        checkedList = checkedList.filter(v => v.userId !== item.userId);
      }
      this.$emit("input", checkedList);
    }
  }
};